import { useEffect, useState } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import type { ITrendsBarValue } from "pro-features/components/TrendsBar/src/TrendsBar";
import { TrendsBar } from "pro-features/components/TrendsBar/src/TrendsBar";

import { LOADER_HEIGHT, LOADER_WIDTH } from "../../constants";
import { trendKeys } from "../automationKeys";

import { trendMock } from "./constants";
import { StyledTrendBar } from "./style";

export const Trends = ({ trendData, isLoading }: { trendData: ITrendsBarValue[]; isLoading: boolean }) => {
    const [trend, setTrend] = useState<ITrendsBarValue[]>(trendMock);
    const { blue, carbon } = colorsPalettes;

    useEffect(() => {
        if (trendData?.length) {
            setTrend(trendData);
        } else {
            setTrend(trendMock);
        }
    }, [isLoading, trendData]);

    return (
        <StyledTrendBar data-automation={trendKeys.container}>
            {isLoading ? (
                <span data-automation={trendKeys.preLoader}>
                    <PixelPlaceholderLoader
                        height={LOADER_HEIGHT}
                        width={LOADER_WIDTH}
                    />
                </span>
            ) : (
                <TrendsBar
                    values={trend}
                    colorsSet={trendData?.length ? [blue[400]] : [carbon[50]]}
                />
            )}
        </StyledTrendBar>
    );
};
